import { createSelector } from 'reselect';

import { rootSelectors } from '@redux/modules/selectors';
import {
  requireHistoryFederalSection,
  requireMultipleCitizenshipRenounced,
  requireCitizenshipForeignPassportsSection,
  requireCitizenshipStatusMaidenName,
  requireCitizenshipStatusForm240Date,
  requireCitizenshipStatusForm240DateExplanation,
  requireCitizenshipStatusResidenceStatus,
  requireCitizenshipStatusAlienRegistrationExpiration,
  requireCitizenshipStatusNotCitizenDocumentFields,
  requireCitizenshipStatusNaturalizedFields,
  requireCitizenshipStatusCitizenshipCertificateFields,
  requireCitizenshipStatusForeignBorn,
  requireCitizenshipStatusDerived,
  requireForeignMilitaryMaintainsContact,
  requireForeignContactsSection,
  requireForeignActivitiesSection,
  requireForeignBusinessSection,
  requireForeignTravelSection,
  requireFinancialBankruptcySection,
  requireFinancialAlimonySection,
  requireFinancialAssetSeizedSection,
  requireFinancialChildSupportSection,
  requireFinancialCivilJudgementSection,
  requireFinancialEvictionSection,
  requireFinancialForeclosureSection,
  requireFinancialLienSection,
  requireFinancialRepossessionSection,
  requireFinancialNonpaymentNonfederalSection,
  requireFinancialBankruptcyTrusteeInformation,
  requireFinancialGamblingSection,
  requireFinancialTaxesSection,
  requireFinancialFederalDebtSection,
  requireFinancialCardDisciplinaryDate,
  requireFinancialCardSection,
  requireFinancialCreditSection,
  requireFinancialDelinquentSection,
  requireFinancialDelinquentName,
  requireFinancialNonpaymentSection,
  allowFinancialDelinquentNonFederal,
  requireDrugWhileSafetySection,
  requireDrugWithClearanceSection,
  requireDrugSupplementalSection,
  requireAlcoholSections,
  requireDrugWhileSafety,
  requireDrugWithClearance,
  requireDrugInFuture,
  requireLegalOtherOffensesSection,
  requireLegalNonCriminalCourtSection,
  requireLegalTechnologySection,
  requireLegalOffenseInvolvements,
  requireLegalOffenseSentenced,
  requireLegalOffenseIncarcerated,
  requireLegalInvestigationClearanceGranted,
  requireForeignCounterIntelligence,
  requireForeignExcessiveKnowledge,
  requireForeignSensitiveInformation,
  requireForeignThreatened,
  requireAlcoholOrderedCounselingParty,
  requireAlcoholReceivedCounselingsSection,
  requireAlcoholSupplementalSection,
  requireLegalPoliceFirearms,
  requireLegalPoliceDrugs,
  requireRelationshipMaritalForeignBornDocExpiration,
  requireRelationshipMaritalDivorcePhoneNumber,
  requireRelationshipCohabitantSSN,
  requireRelationshipMaritalSSN,
  requireRelationshipRelativesForeignBornDoc,
  requireRelationshipRelativesUSResidenceDoc,
  requireRelationshipRelativesForeignGovtAffExplanation,
  requireRelationshipRelativesAPOFPOIDK,
  requireHistoryResidenceReferenceInfo,
  requireHistoryResidenceRole,
  requireEmploymentHistorySupervisorEmail,
  requireEmploymentItemStatus,
  requireEmploymentItemLeft,
  requireEmploymentItemNonGovernment,
  requireEmploymentItemSelfEmploymentVerify,
  requireEmploymentSelfEmployedJobLocation,
  requireSupervisorAddress,
  requireSupervisorHasDifferentAddress,
  requireCitizenshipUsPassportExpiration,
  requireCitizenshipUsPassportName,
  requireHistoryResidenceReferenceName,
  requireHistoryEducationReferenceFields,
  requireIdentificationOtherNameExplanation,
  requireRelationshipRelativesAdditionalFamily,
  requireIdentificationContactInfo,
  requireForeignContactAPOFPOIDK,
} from '../helpers/branches';

export const selectHistoryFederalSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireHistoryFederalSection: requireHistoryFederalSection(formType) })
);

export const selectMultipleCitizenshipRenounced = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireMultipleCitizenshipRenounced: requireMultipleCitizenshipRenounced(formType),
  })
);

export const selectCitizenshipForeignPassportsSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireCitizenshipForeignPassportsSection: requireCitizenshipForeignPassportsSection(formType),
  })
);

export const selectCitizenshipStatusMaidenName = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireCitizenshipStatusMaidenName: requireCitizenshipStatusMaidenName(formType),
  })
);

export const selectCitizenshipStatusForm240Date = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireCitizenshipStatusForm240Date: requireCitizenshipStatusForm240Date(formType),
  })
);

export const selectCitizenshipStatusForm240DateExplanation = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireCitizenshipStatusForm240DateExplanation: requireCitizenshipStatusForm240DateExplanation(
      formType
    ),
  })
);

export const selectCitizenshipStatusResidenceStatus = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireCitizenshipStatusResidenceStatus: requireCitizenshipStatusResidenceStatus(formType),
  })
);

export const selectCitizenshipStatusAlienRegistrationExpiration = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireCitizenshipStatusAlienRegistrationExpiration: requireCitizenshipStatusAlienRegistrationExpiration(
      formType
    ),
  })
);

export const selectCitizenshipStatusNotCitizenDocumentFields = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireCitizenshipStatusNotCitizenDocumentFields: requireCitizenshipStatusNotCitizenDocumentFields(
      formType
    ),
  })
);

export const selectCitizenshipStatusNaturalizedFields = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireCitizenshipStatusNaturalizedFields: requireCitizenshipStatusNaturalizedFields(formType),
  })
);

export const selectCitizenshipStatusCitizenshipCertificateFields = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireCitizenshipStatusCitizenshipCertificateFields: requireCitizenshipStatusCitizenshipCertificateFields(
      formType
    ),
  })
);

export const selectForeignMilitaryMaintainsContact = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireForeignMilitaryMaintainsContact: requireForeignMilitaryMaintainsContact(formType),
  })
);

export const selectForeignContactsSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireForeignContactsSection: requireForeignContactsSection(formType) })
);

export const selectForeignContactAPOFPOIDK = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireForeignContactAPOFPOIDK: requireForeignContactAPOFPOIDK(formType) })
);

export const selectForeignActivitiesSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireForeignActivitiesSection: requireForeignActivitiesSection(formType) })
);

export const selectForeignBusinessSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireForeignBusinessSection: requireForeignBusinessSection(formType) })
);

export const selectForeignTravelSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireForeignTravelSection: requireForeignTravelSection(formType) })
);

export const selectFinancialBankruptcySection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireFinancialBankruptcySection: requireFinancialBankruptcySection(formType) })
);

export const selectFinancialGamblingSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireFinancialGamblingSection: requireFinancialGamblingSection(formType) })
);

export const selectFinancialTaxesSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireFinancialTaxesSection: requireFinancialTaxesSection(formType) })
);

export const selectFinancialCardSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireFinancialCardSection: requireFinancialCardSection(formType) })
);

export const selectFinancialCreditSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireFinancialCreditSection: requireFinancialCreditSection(formType) })
);

export const selectFinancialDelinquentSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireFinancialDelinquentSection: requireFinancialDelinquentSection(formType) })
);

export const selectFinancialDelinquentName = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireFinancialDelinquentName: requireFinancialDelinquentName(formType) })
);

export const selectFinancialDelinquentNonFederal = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    allowFinancialDelinquentNonFederal: allowFinancialDelinquentNonFederal(formType),
  })
);

export const selectFinancialFederalDebtSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireFinancialFederalDebtSection: requireFinancialFederalDebtSection(formType) })
);

export const selectFinancialAlimonySection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireFinancialAlimonySection: requireFinancialAlimonySection(formType) })
);

export const selectFinancialAssetSeizedSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireFinancialAssetSeizedSection: requireFinancialAssetSeizedSection(formType) })
);

export const selectFinancialChildSupportSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireFinancialChildSupportSection: requireFinancialChildSupportSection(formType) })
);

export const selectFinancialCivilJudgementSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireFinancialCivilJudgementSection: requireFinancialCivilJudgementSection(formType) })
);

export const selectFinancialEvictionSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireFinancialEvictionSection: requireFinancialEvictionSection(formType) })
);

export const selectFinancialForeclosureSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireFinancialForeclosureSection: requireFinancialForeclosureSection(formType) })
);

export const selectFinancialLienSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireFinancialLienSection: requireFinancialLienSection(formType) })
);

export const selectFinancialRepossessionSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireFinancialRepossessionSection: requireFinancialRepossessionSection(formType) })
);

export const selectFinancialNonpaymentNonfederalSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireFinancialNonpaymentNonfederalSection: requireFinancialNonpaymentNonfederalSection(formType) })
);

export const selectFinancialNonpaymentSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireFinancialNonpaymentSection: requireFinancialNonpaymentSection(formType) })
);

export const selectFinancialCardDisciplinaryDate = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireFinancialCardDisciplinaryDate: requireFinancialCardDisciplinaryDate(formType),
  })
);

export const selectFinancialBankruptcyTrusteeInformation = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireFinancialBankruptcyTrusteeInformation: requireFinancialBankruptcyTrusteeInformation(
      formType
    ),
  })
);

export const selectDrugWhileSafetySection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireDrugWhileSafetySection: requireDrugWhileSafetySection(formType) })
);

export const selectDrugWithClearanceSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireDrugWithClearanceSection: requireDrugWithClearanceSection(formType) })
);

export const selectDrugSupplementalSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireDrugSupplementalSection: requireDrugSupplementalSection(formType) })
);

export const selectAlcoholSections = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireAlcoholSections: requireAlcoholSections(formType) })
);

export const selectDrugWhileSafety = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireDrugWhileSafety: requireDrugWhileSafety(formType) })
);

export const selectDrugWithClearance = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireDrugWithClearance: requireDrugWithClearance(formType) })
);

export const selectDrugInFuture = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireDrugInFuture: requireDrugInFuture(formType) })
);

export const selectLegalOtherOffensesSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireLegalOtherOffensesSection: requireLegalOtherOffensesSection(formType) })
);

export const selectLegalNonCriminalCourtSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireLegalNonCriminalCourtSection: requireLegalNonCriminalCourtSection(formType),
  })
);

export const selectLegalTechnologySection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireLegalTechnologySection: requireLegalTechnologySection(formType) })
);

export const selectLegalOffenseInvolvements = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireLegalOffenseInvolvements: requireLegalOffenseInvolvements(formType) })
);

export const selectLegalOffenseSentenced = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireLegalOffenseSentenced: requireLegalOffenseSentenced(formType) })
);

export const selectLegalOffenseIncarcerated = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({ requireLegalOffenseIncarcerated: requireLegalOffenseIncarcerated(formType) })
);

export const selectLegalInvestigationClearanceGranted = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireLegalInvestigationClearanceGranted: requireLegalInvestigationClearanceGranted(formType),
  })
);

export const selectForeignCounterIntelligence = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireForeignCounterIntelligence: requireForeignCounterIntelligence(formType),
  })
);

export const selectForeignExcessiveKnowledge = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireForeignExcessiveKnowledge: requireForeignExcessiveKnowledge(formType),
  })
);

export const selectForeignSensitiveInformation = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireForeignSensitiveInformation: requireForeignSensitiveInformation(formType),
  })
);

export const selectForeignThreatened = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireForeignThreatened: requireForeignThreatened(formType),
  })
);

export const selectAlcoholOrderedCounselingParty = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireAlcoholOrderedCounselingParty: requireAlcoholOrderedCounselingParty(formType),
  })
);

export const selectAlcoholReceivedCounselingsSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireAlcoholReceivedCounselingsSection: requireAlcoholReceivedCounselingsSection(formType),
  })
);

export const selectAlcoholSupplementalSection = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireAlcoholSupplementalSection: requireAlcoholSupplementalSection(formType),
  })
);

export const selectLegalPoliceFirearms = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireLegalPoliceFirearms: requireLegalPoliceFirearms(formType),
  })
);

export const selectLegalPoliceDrugs = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireLegalPoliceDrugs: requireLegalPoliceDrugs(formType),
  })
);

export const selectRelationshipMaritalForeignBornDocExpiration = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireRelationshipMaritalForeignBornDocExpiration: requireRelationshipMaritalForeignBornDocExpiration(
      formType
    ),
  })
);

export const selectRelationshipMaritalDivorcePhoneNumber = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireRelationshipMaritalDivorcePhoneNumber: requireRelationshipMaritalDivorcePhoneNumber(
      formType
    ),
  })
);

export const selectRequireRelationshipCohabitantSSN = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireRelationshipCohabitantSSN: requireRelationshipCohabitantSSN(
      formType
    ),
  })
);

export const selectRequireRelationshipMaritalSSN = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireRelationshipMaritalSSN: requireRelationshipMaritalSSN(
      formType
    ),
  })
);

export const selectRelationshipRelativesForeignBornDoc = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireRelationshipRelativesForeignBornDoc: requireRelationshipRelativesForeignBornDoc(
      formType
    ),
  })
);

export const selectRelationshipRelativesUSResidenceDoc = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireRelationshipRelativesUSResidenceDoc: requireRelationshipRelativesUSResidenceDoc(
      formType
    ),
  })
);

export const selectRelationshipRelativesForeignGovtAffExplanation = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireRelationshipRelativesForeignGovtAffExplanation: requireRelationshipRelativesForeignGovtAffExplanation(
      formType
    ),
  })
);

export const selectRelationshipRelativesAPOFPOIDK = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireRelationshipRelativesAPOFPOIDK: requireRelationshipRelativesAPOFPOIDK(formType),
  })
);

export const selectHistoryResidenceReferenceInfo = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireHistoryResidenceReferenceInfo: requireHistoryResidenceReferenceInfo(formType),
  })
);

export const selectHistoryResidenceRole = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireHistoryResidenceRole: requireHistoryResidenceRole(formType),
  })
);

export const selectEmploymentHistorySupervisorEmail = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireEmploymentHistorySupervisorEmail: requireEmploymentHistorySupervisorEmail(formType),
  })
);

export const selectEmploymentItemStatus = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireEmploymentItemStatus: requireEmploymentItemStatus(formType),
  })
);

export const selectEmploymentItemLeft = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireEmploymentItemLeft: requireEmploymentItemLeft(formType),
  })
);

export const selectEmploymentItemNonGovernment = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireEmploymentItemNonGovernment: requireEmploymentItemNonGovernment(formType),
  })
);

export const selectEmploymentItemSelfEmploymentVerify = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireEmploymentItemSelfEmploymentVerify: requireEmploymentItemSelfEmploymentVerify(formType),
  })
);

export const selectEmploymentSelfEmployedJobLocation = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireEmploymentSelfEmployedJobLocation: requireEmploymentSelfEmployedJobLocation(formType),
  })
);

export const selectSupervisorHasDifferentAddress = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireSupervisorHasDifferentAddress: requireSupervisorHasDifferentAddress(formType),
  })
);

export const selectSupervisorAddress = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireSupervisorAddress: requireSupervisorAddress(formType),
  })
);

export const selectCitizenshipUsPassportExpiration = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireCitizenshipUsPassportExpiration: requireCitizenshipUsPassportExpiration(formType),
  })
);

export const selectCitizenshipUsPassportName = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireCitizenshipUsPassportName: requireCitizenshipUsPassportName(formType),
  })
);

export const selectCitizenshipStatusForeignBorn = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireCitizenshipStatusForeignBorn: requireCitizenshipStatusForeignBorn(formType),
  })
);

export const selectCitizenshipStatusDerived = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireCitizenshipStatusDerived: requireCitizenshipStatusDerived(formType),
  })
);

export const selectHistoryResidenceReferenceName = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireHistoryResidenceReferenceName: requireHistoryResidenceReferenceName(formType),
  })
);

export const selectHistoryEducationReferenceFields = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireHistoryEducationReferenceFields: requireHistoryEducationReferenceFields(formType),
  })
);

export const selectIdentificationOtherNameExplanation = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireIdentificationOtherNameExplanation: requireIdentificationOtherNameExplanation(formType),
  })
);

export const selectIdentificationContactInfo = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireIdentificationContactInfo: requireIdentificationContactInfo(formType),
  })
);

export const selectRelationshipRelativesAdditionalFamily = createSelector(
  rootSelectors.application.getFormType,
  (formType) => ({
    requireRelationshipRelativesAdditionalFamily: requireRelationshipRelativesAdditionalFamily(
      formType
    ),
  })
);
